import FlightReservationOrder from './reservation/flightReservationOrder';

export default class FlightPassengerList {
  route: string;
  flightNo: string;
  departureDate: string;
  flightOrders: FlightReservationOrder[];
  operatorCode: string;
  isChecked:boolean;
  totalPax:number;
}
